import { hotjar as org_hotjar } from 'react-hotjar'

// HotJar Initialize
const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID || false
const HOTJAR_SV = process.env.REACT_APP_HOTJAR_SNIPPET_VERSION || false

const HOTJAR_ENABLE = Boolean(HOTJAR_ID && HOTJAR_SV)

const hotjar = {
  initialize: () => {
    if (HOTJAR_ENABLE) {
      org_hotjar.initialize(
        parseInt(HOTJAR_ID || '0'),
        parseInt(HOTJAR_SV || '0')
      )
    }
  },
  identify: (key: string, value: any) => {
    if (HOTJAR_ENABLE) {
      org_hotjar.identify(key, value)
    }
  },
  stateChange: (path) => {
    if (HOTJAR_ENABLE) {
      org_hotjar.stateChange(path)
    }
  },
  event: (event_name: string) => {
    if (HOTJAR_ENABLE) {
      org_hotjar.event(event_name)
    }
  }
}

export default hotjar
